/* eslint-disable capitalized-comments */
import { RouteConfig } from 'vue-router';
import { Role } from './shared/enums/Role.enum';

export const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'installation',
        component: () => import(/* webpackChunkName: "installation" */ './views/Installation.vue'),
    },
    {
        path: '/auth/callback',
        name: 'auth-callback',
        component: () => import(/* webpackChunkName: "HandleCallback" */ './components/auth/HandleCallback.vue'),
        meta: {
            allowAnonymous: true
        }
    },
    {
        path: '/administration',
        name: 'administration',
        component: () => import(/* webpackChunkName: "administration" */ './components/administration/Administration.vue'),
        meta: {
            policy: Role.Administrateur,
        },
        children: [
            {
                path: '',
                redirect: 'utilisateurs'
            },
            {
                path: 'utilisateurs',
                name: 'utilisateurs',
                component: () => import(/* webpackChunkName: "utilisateur" */ './components/administration/utilisateurs/UtilisateurListe.vue'),
                meta: {
                    policy: Role.Administrateur,
                }
            },
            {
                path: '/utilisateur/:idUtilisateur',
                name: 'utilisateurWithId',
                component: () => import(/* webpackChunkName: "utilisateur" */ './components/administration/utilisateurs/Utilisateur.vue'),
                meta: {
                    policy: Role.Administrateur,
                }
            },
            {
                path: 'utilisateur',
                name: 'utilisateur',
                component: () => import(/* webpackChunkName: "utilisateur" */ './components/administration/utilisateurs/Utilisateur.vue'),
                meta: {
                    policy: Role.Administrateur,
                }
            },
            {
                path: 'commandes',
                name: 'commandes',
                component: () => import(/* webpackChunkName: "commande" */ './components/administration/commandes/CommandeListe.vue'),
                meta: {
                    policy: Role.Administrateur,
                }
            },
            {
                path: 'commande',
                name: 'commande',
                component: () => import(/* webpackChunkName: "commande" */ './components/administration/commandes/DetailsCommande.vue'),
                meta: {
                    policy: Role.Administrateur,
                }
            },
            {
                path: 'commande/:id',
                name: 'commandeWithId',
                component: () => import(/* webpackChunkName: "commande" */ './components/administration/commandes/DetailsCommande.vue'),
                meta: {
                    policy: Role.Administrateur,
                }
            },
            {
                path: 'donnees',
                name: 'donnees',
                component: () => import(/* webpackChunkName: "commande" */ './components/administration/donnees-facturation/DonneesFacturation.vue'),
                meta: {
                    policy: Role.Administrateur,
                }
            },
            // {
            //     path: 'cgu',
            //     name: 'cgu',
            //     component: () => import(/* webpackChunkName: "commande" */ './components/administration/cgu/ConditionsGeneralesUtilisation.vue'),
            //     meta: {
            //         policy: Role.Administrateur
            //     }
            // },
            {
                path: 'notifications',
                name: 'notifications',
                component: () => import(/* webpackChunkName: "notifications" */ './components/administration/notifications/Notifications.vue'),
                meta: {
                    policy: Role.Administrateur
                }
            },
            {
                path: 'envoi-vesta',
                name: 'envoi-vesta',
                component: () => import(/* webpackChunkName: "envoi-vesta" */ './components/administration/vesta/EnvoiVesta.vue'),
                meta: {
                    policy: Role.Administrateur
                }
            },
            {
                path: 'template-pos',
                name: 'template-pos',
                component: () => import(/* webpackChunkName: "envoi-vesta" */ './components/administration/templatePos/TemplatePosOnglet.vue'),
                meta: {
                    policy: Role.Administrateur
                }
            },
            {
                path: 'invoicing-datas',
                name: 'invoicing-datas',
                component: () => import(/* webpackChunkName: "invoicing-datas" */ './components/administration/invoicing/InvoicingTab.vue'),
                meta: {
                    policy: Role.Administrateur
                }
            }

        ]
    },
    {
        path: '/utilisateur-mon-compte/:idUtilisateur',
        name: 'utilisateurMonCompte',
        component: () => import(/* webpackChunkName: "utilisateur-mon-compte" */ './components/administration/utilisateurs/UtilisateurMonCompte.vue'),
    },
    {
        path: '/facture',
        name: 'facture',
        component: () => import(/* webpackChunkName: "facture" */ './views/Facture.vue'),
        meta: {
            requiresAuth: true,
            policy: Role.Administrateur,
        }
    },
    {
        path: '/super-admin',
        name: 'superadmin',
        component: () => import(/* webpackChunkName: "facture" */ './components/super-admin/SuperAdmin.vue'),
        meta: {
            policy: Role.Administrateur,
        }
    },
    {
        path: '/facture-erreurs',
        name: 'facture-erreurs',
        component: () => import(/* webpackChunkName: "facture-erreurs" */ './components/facture/erreurs/Erreurs.vue'),
        meta: {
            policy: Role.Administrateur,
        }
    },
    {
        path: '/intrant',
        name: 'intrant',
        component: () => import(/* webpackChunkName: "intrant" */ './views/Intrant.vue'),
    },
    {
        path: '/facture/:idFacture',
        name: 'factureWithId',
        props: (route) => ({ idFacture: Number(route.params.idFacture) }),
        component: () => import(/* webpackChunkName: "facture" */ './components/facture/Facture.vue'),
        children: [
            {
                path: '',
                name: 'factureDetail',
                component: () => import(/* webpackChunkName: "facture" */ './components/facture/facture-detail/FactureDetail.vue'),
            }
        ]
    },
    {
        path: '/intrant/:idContratAchat',
        name: 'intrantWithId',
        component: () => import(/* webpackChunkName: "intrant" */ './components/intrant/Intrant.vue'),
    },
    {
        path: '/suivi-production/:idContratAchat',
        name: 'suivi-production',
        component: () => import(/* webpackChunkName: "suivi-production" */ './views/SuiviProduction.vue'),
    },
    {
        path: '/declaration-pos/',
        name: 'declaration-pos',
        component: () => import(/* webpackChunkName: "declaration-pos" */ './components/pos/ListeDeclarationsPos.vue'),
    },
    {
        path: '/utilisateur',
        component: () => import(/* webpackChunkName: "utilisateur" */ './components/administration/utilisateurs/Utilisateur.vue'),
        meta: {
            policy: Role.Administrateur,
        }
    },
    {
        path: '/mandat',
        name: 'mandat',
        component: () => import('./views/Mandat.vue'),
    },
    {
        path: '/creation-mandat',
        name: 'creation-mandat',
        redirect: { name: 'step1' },
        component: () => import('./components/mandat/CreationMandat.vue'),
        children: [
            {
                path: 'step1',
                name: 'step1',
                component: () => import('./components/mandat/Step1CreationMandat.vue'),
            },
            {
                path: 'step2',
                name: 'step2',
                component: () => import('./components/mandat/Step2CreationMandat.vue'),
            }
        ]
    }
];
